import React, { useContext } from 'react';
import { useTheme } from '@mui/material/styles';
import { IconProps } from './iconProps';
import { UiContext } from 'shared/lib/contexts/uiContext';
import cx from 'classnames';
import { defaultSpacingPresets } from 'shared/hooks/useGetSpacing';

export default function IconLink({
  extColor,
  isAutoscallable = true,
  sizeKey = '24x24',
  onClick,
  style,
}: IconProps) {
  const theme = useTheme();
  const fill = extColor || theme.palette.primary.main;
  const {
    spacings: {
      icons: { [sizeKey]: size },
    },
  } = useContext(UiContext);

  const w = isAutoscallable ? size.w : defaultSpacingPresets.icons[sizeKey].w;
  const h = isAutoscallable ? size.h : defaultSpacingPresets.icons[sizeKey].h;

  return (
    <svg
      className={cx('icon', { 'icon-disabled': !onClick })}
      onClick={onClick}
      style={style}
      width={w}
      height={h}
      viewBox="0 0 20 10"
      fill={fill}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M9 10H5C3.61667 10 2.4375 9.5125 1.4625 8.5375C0.4875 7.5625 0 6.38333 0 5C0 3.61667 0.4875 2.4375 1.4625 1.4625C2.4375 0.4875 3.61667 0 5 0H9V2H5C4.16667 2 3.45833 2.29167 2.875 2.875C2.29167 3.45833 2 4.16667 2 5C2 5.83333 2.29167 6.54167 2.875 7.125C3.45833 7.70833 4.16667 8 5 8H9V10ZM6 6V4H14V6H6ZM11 10V8H15C15.8333 8 16.5417 7.70833 17.125 7.125C17.7083 6.54167 18 5.83333 18 5C18 4.16667 17.7083 3.45833 17.125 2.875C16.5417 2.29167 15.8333 2 15 2H11V0H15C16.3833 0 17.5625 0.4875 18.5375 1.4625C19.5125 2.4375 20 3.61667 20 5C20 6.38333 19.5125 7.5625 18.5375 8.5375C17.5625 9.5125 16.3833 10 15 10H11Z" />
    </svg>
  );
}
